import {dataPropertyOptions} from './shape/config/shape-config'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import ThresholdColorsDialog from 'scoreboard/components/threshold-colors/threshold-colors-dialog'
import { NUMBER } from '../../datasets/model/data-type'
import { dataTypeForInitCalcType } from '../../initiatives/format-initiative-calculations'
import { getThresholdColorsModel } from '../../components/thresholds-and-colors'
import { INITIATIVES } from '../../components/sections'
import DataSourceWidgetConfigMenu from './data-source-widget-config-menu'
import i18n from 'scoreboard/components/i18n'
import EditLabel from 'scoreboard/components/designer/edit-label'
import defaultDataSourceLabel from './default-data-source-label'

const BaseGaugeConfig = DataSourceWidgetConfigMenu.extend({

	/** @type {BaseGaugeModel} */
	model: null,

	/**
	 * Returns the options that should be specified for the "Create Data
	 * Source" menu option
	 */
	createDataSourceOptionOptions: function() {
		return {
			model: this.model,
			showDataProperty: section => section === 'initiatives',
			dataPropertyOptions: ({ domainType, dataSource, domainObject }) => {
				return dataPropertyOptions({
					model: this.model,
					domainType,
					dataSource,
					domainObject
				})
			},
			dataSourceSelectorOptions: {
				restrictTemporalToNumUnique: true
			},
			dataset: this.model.dataset(),
			widgetUpdater: this.options.widgetUpdater
		}
	},

	/** Creates the "Set Thresholds" menu option */
	createThresholdsOption: function() {
		const viewCreator = () => {
			let gaugeOptions = this.model.gaugeOptions()

			let dataType = gaugeOptions.dataType ?? NUMBER
			if (this.model.section() == INITIATIVES) {
				let initCalcType = this.model.properties.get('dataSourceProperty')
				dataType = dataTypeForInitCalcType(initCalcType)
			}
			return new ThresholdColorsDialog({
				model: getThresholdColorsModel(gaugeOptions),
				dataType,
				currencyCode: gaugeOptions.currencyCode,
				precision: gaugeOptions.precision,
				title: i18n.get('dashboards.setThresholds'),
				isGaugeWidget: true
			})
		}

		let option = BootslideMenu.targetOption(
			'dashboards.setThresholds', viewCreator, colorModel => {
				this.model.wob.set('thresholdColoring', colorModel.toJSON())
			})

		option.type = 'dialog'
		option.id = 'setThresholds'
		return option
	},

	/**
	 * Creates the "Showing" sub-menu
	 */
	createShowingOption: function() {
		return {
			type: 'submenu',
			label: 'common.showing',
			target: this.getShowingOptions(),
			width: 250
		}
	},

	/** Returns the items to display in the "Showing" sub-menu */
	getShowingOptions: function() {
		var showingOptions = this.model.validShowProperties().map(function (prop) {
			return {
				label: prop.label,
				contentView: BootslideMenu.WidgetToggleProperty.extend({
					property: { label: prop.label, name: prop.property }
				}),
				model: this.model.properties
			}
		}.bind(this))
		return showingOptions
	},

	/**
	 * Creates the "Set Name" menu option. Note that the generic term `label` is
	 * used in the code; some widgets call it a Title instead, but all widgets
	 * use the standard `label` term in the code.
	 */
	createSetNameOption () {
		let header = i18n.get('charts.series.setLabel')
		let option = BootslideMenu.targetOption(header, () => {
			let label = this.model.properties.get('label')
			return new EditLabel({
				default: !label,
				label: label ?? defaultDataSourceLabel(this.model),
				header,
				inputLabel: 'common.name',
				toggleLabel: 'charts.series.labelType',
				doneKey: 'common.done'
			})
		}, (label) => this.setLabel(label))
		option.type = 'dialog'
		return option
	},

	setLabel (label) {
		this.model.properties.set('label', label)
	}

})

export default BaseGaugeConfig

BaseGaugeConfig.__filename__ = 'dashboards/widgets/base-gauge-config.js'
